/**
 * Build-target constants. Single source of truth for which routes a given
 * frontend bundle includes.
 *
 * REACT_APP_TARGET is set at build time:
 *   - unset (default)   → mounts every route (used by Emergent preview + dev)
 *   - "all"             → same as unset (explicit form)
 *   - "user"            → User App only (Home, AI Chat, Lawyers, Booking, ConsultationRoom, Articles, Dashboard)
 *   - "lawyer"          → Lawyer Portal only — bundle mounts <LawyerApp /> at "/"
 *   - "admin"           → Admin App only — bundle mounts <AdminApp /> at "/"
 *
 * Build commands:
 *   yarn build            ← traditional combined bundle (Emergent preview)
 *   yarn build:user       ← User App only
 *   yarn build:lawyer     ← Lawyer App only
 *   yarn build:admin      ← Admin App only
 */
export const BUILD_TARGET = (process.env.REACT_APP_TARGET || "all").toLowerCase();

export const IS_COMBINED = BUILD_TARGET === "all";
export const IS_USER = BUILD_TARGET === "user";
export const IS_LAWYER = BUILD_TARGET === "lawyer";
export const IS_ADMIN = BUILD_TARGET === "admin";
